export default {
	serviceProvider: null,
	vuexModule: "members",
	queryParams: {
		company_id: null,
	},
	headerColumns: [
		{
			prop: "user",
			keys: ["user.first_name", "user.email"],
			label: "Name",
			minWidth: 250,
			searchable: true,
			sortable: true,
			sortBy: "user.first_name",
		},
		{
			prop: "user_email",
			keys: ["user_email"],
			label: "Email",
			minWidth: 250,
			searchable: true,
			sortable: true,
		},
		{
			prop: "type",
			keys: ["type"],
			label: "Type",
			minWidth: 160,
			searchable: true,
			sortable: true,
		},
		{
			prop: "report_count",
            keys: ["report_count"],
			label: "Reports",
			minWidth: 160,
			class: "text-center",
            searchable: true,
			labelClass: "justify-content-center",
			sortable: true,
		},
		{
			prop: "user",
			keys: ["user.date_joined"],
			label: "Date Joined",
			minWidth: 195,
			searchable: true,
			sortable: true,
			sortBy: "user.date_joined",
			searchType: "date",
		},
		{
			prop: "user",
			keys: ["user.last_login"],
			label: "Last Login",
			minWidth: 185,
			searchable: true,
			sortable: true,
			sortBy: "user.last_login",
			searchType: "date",
		},
        {
			prop: "cash_call_approver",
			keys: ["cash_call_approver"],
			label: "Cash Call Approver",
			width: 250,
			sortable: true,
		},
        {
          prop: 'billing_contact',
          keys: ['billing_contact'],
          label: 'Billing Contact',
          width: 210,
          sortable: true,
        },
        {
          prop: 'user_rec_status',
          keys: ['user_rec_status'],
          label: 'REC STATUS',
          width: 160,
          sortable: true,
        },
		{
			prop: "status",
			keys: ["status"],
			label: "Status",
			width: 140,
			sortable: true,
		},
	],
};
